// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"bc95c9c8","44":"331d5779","118":"1df6419f","138":"845aa4e0","223":"a5629a3c","343":"3f243e0a","453":"3cb1ae6e","524":"30313ea4","569":"6c98365e","862":"6b824b52","900":"33f1684f","939":"f627b1d7"}[chunkId] + ".chunk.js";
};